<div class="dashboard-toolbar">
  <h2 class="dashboard-title"
      *ngIf="showDashboardNameOnScreen && configurations?.['dashboard-name']"
      [style.font-size]="dashboardNameFontSize || null">
    {{ configurations['dashboard-name'] | capitalCase }}
  </h2>

  @if (layoutEditEnabled) {
  <div class="layout-toolbar-actions">
    @if (!editMode) {
    <button type="button" class="layout-mode-toggle" (click)="enterEditMode()">
      Edit Layout
    </button>
    } @else {
    <div class="layout-save-actions">
      <button type="button" class="layout-cancel-action" (click)="cancelEditMode()">
        Cancel
      </button>
      <button type="button" class="layout-mode-toggle editing" (click)="saveMyLayout()">
        {{ layoutSavePersonalLabel }}
      </button>
      @if (canSaveDefaultLayout) {
      <button type="button" class="layout-default-action" (click)="saveDefaultLayout()">
        {{ layoutSaveDefaultLabel }}
      </button>
      }
    </div>
    }
  </div>
  }
</div>

@if (configurations?.filters) {
<app-global-filter [config]="configurations?.filters"></app-global-filter>
}

<div #dashboardContent class="dashboard-content" [class.no-scroll-content]="!effectiveScreenFloating">
  @if (useRecursiveRenderer) {
  <div class="dashboard-recursive-layout">
    <ng-template #layoutRows let-rows>
      @for (row of rows; track trackByNodeId($index, row)) {
      <div [class]="getRowClass(row)">
        @for (column of row?.columns || []; track trackByNodeId($index, column)) {
        <div [class]="getColumnClass(column)" [ngStyle]="getColumnStyle(column)">
          @if (resolveLayoutWidget(column); as layoutWidget) {
          @defer (on viewport) {
          <app-widget-renderer [charts]="layoutWidget.widget"></app-widget-renderer>
          } @placeholder {
          <div style="min-height: 180px;"></div>
          }
          }

          @if (hasNestedRows(column)) {
          <div [class]="getNestedRowsContainerClass(column)">
            <ng-container *ngTemplateOutlet="layoutRows; context: { $implicit: column.rows }"></ng-container>
          </div>
          }
        </div>
        }
      </div>
      }
    </ng-template>

    <ng-container *ngTemplateOutlet="layoutRows; context: { $implicit: configurations?.pageContent || [] }"></ng-container>
  </div>
  } @else {
  <div #gridContainer class="dashboard-grid" [class.editing]="editMode" [class.interacting]="isInteracting"
    [class.has-focus]="hasFocusWidget" [ngStyle]="gridStyle">

    @for (entry of viewItems; track entry.item.id) {
    <article class="grid-widget" [class.dragging]="isDragging(entry.item.id)"
      [class.resizing]="isResizing(entry.item.id)" [class.locked]="entry.item.locked" [class.editing]="editMode"
      [class.focused]="isFocused(entry.item.id)" [attr.data-widget-id]="entry.item.id"
      (pointerdown)="onWidgetPointerDown($event, entry.item)" [ngStyle]="widgetStyle(entry.item)">

      <!-- Widget Renderer with lazy loading -->
      @defer (on viewport) {
      <app-widget-renderer [charts]="entry.rec.widget">
      </app-widget-renderer>
      } @placeholder {
      <div style="min-height: 180px;"></div>
      }

      <!-- Focus Mode Toggle -->
      @if (canShowFocusToggle(entry.rec.widget)) {
      <button type="button" class="focus-mode-toggle" [class.active]="isFocused(entry.item.id)" [attr.aria-label]="
              focusToggleLabel(entry.item.id, entry.rec.widget)
            " [matTooltip]="focusToggleLabel(entry.item.id, entry.rec.widget)"
        matTooltipClass="dvm-focus-toggle-tooltip"
        (pointerdown)="onFocusTogglePointerDown($event)" (click)="toggleFocus(entry.item.id)">
        <span class="material-icons">{{ focusToggleIcon(entry.item.id) }}</span>
      </button>
      }

      <!-- Resize Handles -->
      <button type="button" class="resize-handle resize-nw" [disabled]="!canResize(entry.item)"
        [attr.aria-label]="'Resize ' + label(entry.rec.widget)"
        (pointerdown)="startResize($event, entry.item, 'nw')"></button>

      <button type="button" class="resize-handle resize-ne" [disabled]="!canResize(entry.item)"
        [attr.aria-label]="'Resize ' + label(entry.rec.widget)"
        (pointerdown)="startResize($event, entry.item, 'ne')"></button>

      <button type="button" class="resize-handle resize-sw" [disabled]="!canResize(entry.item)"
        [attr.aria-label]="'Resize ' + label(entry.rec.widget)"
        (pointerdown)="startResize($event, entry.item, 'sw')"></button>

      <button type="button" class="resize-handle resize-se" [disabled]="!canResize(entry.item)"
        [attr.aria-label]="'Resize ' + label(entry.rec.widget)"
        (pointerdown)="startResize($event, entry.item, 'se')"></button>

    </article>
    }

  </div>
  }
</div>
